import React, { useState, useEffect } from "react";
import { Card, Row, Col, Table } from "antd";
import moment from "moment";



const truncateTitle = (str) => {
    return str.length > 50 ? str.substring(0, 50) + "..." : str;
};

const truncateDescription = (str) => {
    return str.length > 90 ? str.substring(0, 90) + "..." : str;
};



const Notification = ({ dispatch, items, initialPagination, filters, totalCount, isLoading }) => {
    const initialPaginationTable = {
        showSizeChanger: true,
        pageSizeOptions: [5, 10, 15, 20, 25],
        pageSize: initialPagination.pageSize,
        current: initialPagination.currentPage,
        total: totalCount,
        showTotal: (total, range) => `${range[0]}-${range[1]} nga ${total} `,
    };


    const [paginationTable, setPaginationTable] = useState(
        initialPaginationTable
    );


    useEffect(() => {
        setPaginationTable({
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 15, 20, 25],
            pageSize: initialPagination.pageSize,
            current: initialPagination.currentPage,
            total: totalCount,
            showTotal: (total, range) => `${range[0]}-${range[1]} nga ${total} `,
        });
    }, [initialPagination, totalCount]);


    const handleTableChange = (pagination, filters, sorter) => {
        setPaginationTable({
            ...pagination,
            showTotal: (total, range) => `${range[0]}-${range[1]} nga ${total} `,
        });
        const action = {
            type: "set_table_pagination",
            payload: {
                pageSize: pagination.pageSize,
                currentPage: pagination.current,
            }
        };
        dispatch(action);
    };


    const formatBody = (body) => {
        return body.replace(/<(?:.|\n)*?>/gm, ' ');
    };


    const tableColumns = [
        {
            title: '#',
            dataIndex: "row_number",
            className: 'mail-list-sender',
            render: (_, elm) => (
                <b>{elm.row_number}</b>
            ),
            align: "center",
            width: 50
        },
        {
            title: 'Titulli',
            dataIndex: "title",
            className: 'mail-list-content',
            render: (_, elm) => (
                <div className=" mail-list-content-msg">
                    <span className="font-weight-semibold text-dark ml-1">{truncateTitle(elm.title)}</span>
                </div>
            ),
            width: 250
        },
        {
            title: 'Përshkrimi',
            dataIndex: "title",
            className: 'mail-list-content',
            render: (_, elm) => (
                <div className=" mail-list-content-msg">
                    <span className="p mb-0">{formatBody(truncateDescription(elm.description))}</span>
                </div>
            ),
            width: 350
        },
        {
            title: 'Data',
            dataIndex: 'notification_date',
            className: 'mail-list-date',
            render: (_, elm) => (
                <div>{moment(elm.create_date).format('DD-MM-YYYY, HH:mm')}</div>
            ),
            align: "center",
            width: 150
        },
    ];


    // const locale = {
    //     emptyText: (
    //         <div className="text-center my-5">
    //             <h3 className="mt-3 font-weight-bold">Nuk ka njoftime!</h3>
    //         </div>
    //     )
    // };


    const onView = (item) => {
        const action = {
            type: "open_consult_view",
            payload: {
                item: item,
                indexVisibility: 1
            },
        };
        dispatch(action);
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Card bodyStyle={{ padding: "0" }} style={{ borderRadius: "0" }}>
                    <Table
                        style={{ cursor: "pointer" }}
                        columns={tableColumns}
                        bordered={true}
                        showHeader={true}
                        dataSource={items}
                        pagination={paginationTable}
                        loading={isLoading}
                        onChange={handleTableChange}
                        scroll={{
                            x: 800,
                        }}
                        onRow={(elm) => {
                            return {
                                onClick: e => {
                                    e.preventDefault();
                                    onView(elm);
                                }
                            };
                        }}
                        rowKey='id'
                        size="small"
                    />
                </Card>
            </Col>
        </Row>
    );
};


export default Notification;